import CopyButton from "./CopyButton";

<div style={{ maxWidth: "600px" }}>

## Basic Usage

One click writes `text` to the clipboard, and the icon swaps to a check for ~3s.
Hover for a tooltip; the tooltip text mirrors the aria-label (changes from
"Copy" → "Copied to clipboard" after a successful write).

<CopyButton text="hello from the design system" />

---

## Custom Labels

`copyLabel` and `copiedLabel` customize the tooltip + aria-label pair.

<CopyButton text="some-uuid-1234-5678" copyLabel="Copy ID" copiedLabel="ID copied" />

---

## Sizes

Inherits sizing from `IconButton`. Choose `btnSize` per surface — `small` is
the default for inline use inside chat-bubble headers.

<div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
  <CopyButton text="xsmall" btnSize="xsmall" />
  <CopyButton text="small" btnSize="small" />
  <CopyButton text="medium" btnSize="medium" />
  <CopyButton text="large" btnSize="large" />
</div>

---

## Inside a Header Row

The intended placement: a small tertiary icon-button at the trailing edge of
a row that already provides the text being copied (e.g. a message bubble,
a code snippet, a generated value).

<div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0.5rem 0.75rem",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    maxWidth: "320px",
  }}
>
  <code style={{ fontFamily: "monospace" }}>plan-id: 9ab12c</code>
  <CopyButton text="plan-id: 9ab12c" btnSize="small" btnStyle="tertiary" />
</div>

</div>
